export default "__VITE_ASSET__SV0LGLNJ__"